import React from 'react';
import { useState, useEffect } from "react";
import GerminationTrayCard from "Components/GerminationTrayCard";
import { DebounceInput } from "react-debounce-input";
import CreateIcon from "Assets/CreateIcon";
import Modal from "react-modal";
import ModalStyle from "Assets/ModalStyle";

import { useGerminationTrayStore } from "Store/GerminationTrayStore";

const GerminationTrays = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);

  const [name, setName] = useState("");
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const fetchTrays = useGerminationTrayStore((state) => state.getGerminationTrays);
  const fetchTraysByName = useGerminationTrayStore((state) => state.getTraysByName);
  const createGerminationTray = useGerminationTrayStore((state) => state.createGerminationTray);
  const germinationTrays = useGerminationTrayStore((state) => state.germinationTrays);

  useEffect(() => {
    void fetchTrays();
  }, [fetchTrays]);

  const createTray = async () => {
    const plantingIds = new Array(width * height).fill(null);
    const body = {
      name,
      width,
      height,
      plantingIds,
    };

    await createGerminationTray(body);
  };

  return (
    <div>
      <button
        onClick={() => setShowCreateModal(true)}
        className="btn p-15 bg-[darkgreen] circle fixed bottom-5 left-5"
      >
        <CreateIcon />
      </button>
      <div className="px-10 justify-between items-center pt-10">
        <h2 className="text-4xl text-center my-0 mx-auto">Trays</h2>
        <DebounceInput
          className="border-solid border rounded border-gray px-10 py-3 w-300 my-5"
          placeholder={"Search"}
          minLength={2}
          debounceTimeout={300}
          onChange={async (event) => {
            await fetchTraysByName(event.target.value);
          }}
        />
      </div>

      <div className="flex flex-wrap align-items-center justify-center">
        {germinationTrays?.map((germinationTray) => {
          return (
            <GerminationTrayCard key={germinationTray._id} trayId={germinationTray._id} />
          );
        })}
      </div>

      <Modal style={ModalStyle.defaultStyle} ariaHideApp={false} isOpen={showCreateModal}>
        <div className="m-50 p-5">
          <h3 className="text-lg py-5">Create Germination Tray</h3>
          <input
            placeholder="Name"
            onChange={(e) => setName(e.target.value)}
            className="modal-input"
          />
          <input
            placeholder="Columns"
            onChange={(e) => setWidth(Number.parseInt(e.target.value))}
            className="modal-input"
          />
          <input
            placeholder="Rows"
            onChange={(e) => setHeight(Number.parseInt(e.target.value))}
            className="modal-input"
          />

          <div className="flex pt-10">
            <button
              onClick={() => setShowCreateModal(false)}
              className="btn bg-gray-light mr-5"
            >
              Cancel
            </button>
            <button
              onClick={async () => {
                await createTray();
                setShowCreateModal(false);
              }}
              className="btn btn-green"
            >
              Create
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default GerminationTrays;
